import React, { Component } from 'react';
import 'swiper/css/swiper.min.css';
import './HorizontalImageSwiper.css';
import { qNavSelectedLine } from 'on_web/assets/imageList';
import { APP_PRIMARY } from 'colours';

/**
 * Component representing one item horizontal swiper control for images.
 */
export default class HorizontalImageSwiperItem extends Component {
  render() {
    return (
      <div
        className={
          this.props.containerClassName ? this.props.containerClassName : ''
        }
      >
        <div>
          {this.props.leftDots ? (
            <img
              src={qNavSelectedLine}
              alt="line"
              width="25px"
              height="4px"
              style={{
                marginBottom: '16px',
              }}
            />
          ) : (
            ''
          )}

          {this.props.icon && (
            <img
              src={this.props.icon}
              height={this.props.largeIconSize ? '44px' : '36px'}
              width={this.props.largeIconSize ? '44px' : '36px'}
              alt="step"
              style={{
                marginRight: this.props.rightDots === false ? '25px' : '0',
                marginLeft: this.props.leftDots === false ? '25px' : '0',
              }}
            />
          )}

          {this.props.rightDots ? (
            <img
              src={qNavSelectedLine}
              alt="line"
              width="25px"
              height="4px"
              style={{
                marginBottom: '16px',
              }}
            />
          ) : (
            ''
          )}
        </div>
        <div
          className="swiper-text-size"
          style={{
            fontFamily: 'Museo',
            fontSize: '14px',
            fontWeight: 'bold',
            lineHeight: '1',
            color: this.props.textColor ? this.props.textColor : APP_PRIMARY,
            marginRight: this.props.rightDots === false ? '40px' : '0',
          }}
        >
          {this.props.text !== '' && <span>{this.props.text}</span>}
          {this.props.text === '' && <span>&nbsp;</span>}
        </div>
      </div>
    );
  }
}
